import React, { useEffect, useState, useCallback } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { Accordion, Button, Card, Modal, Spinner } from "react-bootstrap";
import { Select } from "antd";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import { useTranslation } from "react-i18next";
import {
  fetchTimeRangeList,
  fetchEmailEmployeeName,
  fetchOrgLevelList,
  addEmailSettings,
  fetchEmailSettingsList,
  sortEmailSettingsList,
  deleteEmailSettings,
  addTimeSettings,
} from "./actions";

function DailyProgress() {
  const [lang] = useTranslation("language");
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [wwid, setWWID] = useState("");
  const [loginName, setLoginName] = useState("");
  const [buID, setBuID] = useState("");
  const [name, setName] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [period, setPeriod] = useState("companyWide");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [maintenanceTime, setMaintenanceTime] = useState({
    label: "9:00～9:59",
    value: "04",
  });
  const [total, setTotal] = useState();
  const [limit, setLimit] = useState(40);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [salesOfficeLoading, setSalesOfficeLoading] = useState(false);
  const [branchLoading, setBranchLoading] = useState(false);
  const [salesDivisionLoading, setSalesDivisionLoading] = useState(false);
  const [timeLoading, setTimeLoading] = useState(false);
  const [showTime, setShowTime] = useState(false);
  const [timeMessage, setTimeMessage] = useState("");
  const [showTimeMessage, setShowTimeMessage] = useState(false);
  const [sortOrgCode, setSortOrgCode] = useState("asc");
  const [sortOrgName, setSortOrgName] = useState("asc");
  const [sortOrgLevel, setSortOrgLevel] = useState("asc");
  const [sortModifiedTime, setSortModifiedTime] = useState("asc");
  const [sortModifiedUser, setSortModifiedUser] = useState("asc");
  const [timeRangeList, setTimeRangeList] = useState([]);
  const [buList, setBUList] = useState([]);
  const [salesDivisionList, setSalesDivisionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [salesOfficeList, setSalesOfficeList] = useState([]);

  const [selectedBU, setSelectedBU] = useState([]);
  const [selectedSalesDivision, setSelectedSalesDivision] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedSalesOffice, setSelectedSalesOffice] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const [isCheckBoxSelected, setIsCheckBoxSelected] = useState([]);

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("SalesMenu.emailSetting")}`,
      path: "/monthlySelloutReportCA",
    },
  ];

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  useEffect(() => {
    let token = sessionStorage.getItem("token");
    let wwid = sessionStorage.getItem("WWID");
    sessionStorage.setItem("return_url", "/dailyProgress");
    getTimeRangeList();
    getBUList();
    let body = {
      id: wwid,
      limit: 0,
    };
    token && getEmailSettingsList(body);
    setWWID(wwid);
    setName(sessionStorage.getItem("Username"));
    setLoginName(sessionStorage.getItem("Kanji name"));
  }, []);

  /*** 
    @purpose : Close modal
    @Parameter : {}
    **/
  const handleClose = () => setShow(false);

  /*** 
    @purpose : Close success message modal
    @Parameter : {}
    **/
  const handleCloseSuccessMessage = () => setShowSuccessMessage(false);

  /*** 
    @purpose : Close time modal
    @Parameter : {}
    **/
  const handleCloseTime = () => setShowTime(false);

  /*** 
    @purpose : Close time message modal
    @Parameter : {}
    **/
  const handleCloseTimeMessage = () => setShowTimeMessage(false);

  /*** 
    @purpose : Handle sorting
    @Parameter : {obj}
    **/
  const handleSortingData = (obj) => {
    obj.column === "org_code" && setSortOrgCode(obj.sortOrder);
    obj.column === "org_name" && setSortOrgName(obj.sortOrder);
    obj.column === "jp_org_level" && setSortOrgLevel(obj.sortOrder);
    obj.column === "modified_date_time" && setSortModifiedTime(obj.sortOrder);
    obj.column === "modified_by_user" && setSortModifiedUser(obj.sortOrder);
    let body = {
      id: wwid,
      sort_field: obj.column,
      sort_order: obj.sortOrder,
      limit: limit,
    };
    getSortedEmailSettingsList(body);
  };

  /*** 
    @purpose : Handle BU change
    @Parameter : {value}
    **/
  const handleBUChange = async (value) => {
    if (value.length > 0) {
      setSalesDivisionLoading(true);
      setSelectedBU(value);
      setSelectedSalesDivision([]);
      setSelectedBranch([]);
      setSelectedSalesOffice([]);
      setSalesDivisionList([]);
      let body = {
        self_level_no: 4,
        parent_code: value,
      };
      await fetchOrgLevelList(body).then((response) => {
        let newList = [];
        setSalesDivisionLoading(false);
        if (response && response.data && response.data.length > 0) {
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.org_code,
              label: item.org_abbr,
            });
          }
          setSalesDivisionList(newList);
        }
      });
    } else if (value.length === 0) {
      setSelectedBU([]);
      setSelectedSalesDivision([]);
      setSelectedBranch([]);
      setSelectedSalesOffice([]);
    }
  };

  /*** 
    @purpose : Handle sales division change
    @Parameter : {value}
    **/
  const handleSalesDivisionChange = async (value) => {
    if (value.length > 0) {
      setBranchLoading(true);
      setSelectedSalesDivision(value);
      setSelectedBranch([]);
      setSelectedSalesOffice([]);
      let body = {
        self_level_no: 5,
        parent_code: value,
      };
      await fetchOrgLevelList(body).then((response) => {
        setBranchLoading(false);
        if (response && response.data && response.data.length > 0) {
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.org_code,
              label: item.org_abbr,
            });
          }
          setBranchList(newList);
        }
      });
    } else if (value.length === 0) {
      setSelectedSalesDivision([]);
      setSelectedBranch([]);
      setSelectedSalesOffice([]);
    }
  };

  /*** 
    @purpose : Handle branch change
    @Parameter : {value}
    **/
  const handleBranchChange = async (value) => {
    if (value.length > 0) {
      setSelectedBranch(value);
      setSelectedSalesOffice([]);
      let body = {
        self_level_no: 6,
        parent_code: value,
      };
      await fetchOrgLevelList(body).then((response) => {
        if (response.data.length > 0) {
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.org_code,
              label: item.org_abbr,
            });
          }
          setSalesOfficeList(newList);
        }
      });
    } else if (value.length === 0) {
      setSelectedBranch([]);
      setSelectedSalesOffice([]);
    }
  };

  /*** 
    @purpose : Handle sales office change
    @Parameter : {value}
    **/
  const handleSalesOfficeChange = (value) => {
    if (value.length > 0) {
      setSelectedSalesOffice(value);
    } else if (value.length === 0) {
      setSelectedSalesOffice([]);
    }
  };

  /*** 
    @purpose : Handle period
    @Parameter : {e}
    **/
  const handlePeriod = (e) => {
    setPeriod(e.target.value);
  };

  /*** 
    @purpose : Get time range list
    @Parameter : {}
    **/
  const getTimeRangeList = async () => {
    await fetchTimeRangeList().then((response) => {
      let newList = [];
      for (let index = 0; index < response.length; index++) {
        const item = response[index];
        newList.push({
          value: item.value,
          label: item.key,
        });
      }
      setTimeRangeList(newList);
    });
  };

  /*** 
    @purpose : Get employee by wwid
    @Parameter : {}
    **/
  const getEmployeeByWwid = async () => {
    setEmployeeLoading(true);
    await fetchEmailEmployeeName(wwid).then((response) => {
      if (response && response.name) {
        setEmployeeLoading(false);
        setLoginName(response && response.name);
      }
    });
  };

  /*** 
    @purpose : Get BU list
    @Parameter : {}
    **/
  const getBUList = async () => {
    let body = {
      self_level_no: 3,
      parent_code: [],
    };
    await fetchOrgLevelList(body).then((response) => {
      let newList = [];
      for (let index = 0; index < response.data.length; index++) {
        const item = response.data[index];
        newList.push({
          value: item.org_code,
          label: item.org_abbr,
        });
      }
      setBUList(newList);
    });
  };

  /*** 
    @purpose : Handle delivery time
    @Parameter : {value}
    **/
  const handleDeliveryTime = (value) => {
    setMaintenanceTime(value);
    setDeliveryTime(value.value);
  };

  /*** 
    @purpose : Handle checkbox
    @Parameter : {e}
    **/
  const handleCheckbox = (e) => {
    let tempListing = [...emailList];
    let checkedAll = allChecked;

    if (e.target.value === "checkAll") {
      tempListing.forEach((item) => {
        item.isChecked = e.target.checked;
        checkedAll = e.target.checked;
      });
    } else if (e.target.value !== "checkAll") {
      tempListing.forEach((item) => {
        if (item.id == e.target.value) {
          item.isChecked = e.target.checked;
        }
      });
    }
    setEmailList(tempListing);
    setAllChecked(checkedAll);
    setIsCheckBoxSelected(emailList.filter((el) => el.isChecked === true));
  };

  /*** 
    @purpose : Handle add email settings
    @Parameter : {}
    **/
  const handleAddEmailSettings = async () => {
    let orgCode = [];
    let orgLevel = "";
    if (period === "bu") {
      orgLevel = "03";
      orgCode = selectedBU;
    } else if (period === "salesDivision") {
      orgLevel = "04";
      orgCode = selectedSalesDivision;
    } else if (period === "branch") {
      orgLevel = "05";
      orgCode = selectedBranch;
    } else if (period === "salesOffice") {
      orgLevel = "06";
      orgCode = selectedSalesOffice;
    } else if (period === "companyWide") {
      orgLevel = "01";
      orgCode = [];
    }
    let body = {
      wwid: wwid,
      email_delivery_time: maintenanceTime.value,
      org_code: orgCode,
      jp_organization_level: orgLevel,
    };
    if (orgLevel !== "") {
      setIsLoading(true);
      await addEmailSettings(body).then((response) => {
        setIsLoading(false);
        if (response.success === true) {
          setSuccessMessage(response.data);
          setShowSuccessMessage(true);
          let payload = {
            id: wwid,
            limit: 0,
          };
          getEmailSettingsList(payload);
        }
      });
    }
  };

  /*** 
    @purpose : Get email settings list
    @Parameter : {body}
    **/
  const getEmailSettingsList = async (body) => {
    sessionStorage.setItem("return_url", "")
    setEmailList([]);
    setLoading(true);
    await fetchEmailSettingsList(body).then((response) => {
      if (response && response.data) {
        setLoading(false);
        setNoData(false);
        let time = {
          value: response && response.mail_delivery_time.value,
          label: response && response.mail_delivery_time.key,
        };
        setMaintenanceTime(time);
        var result =
          response &&
          response.data &&
          response.data &&
          response.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });
        setEmailList(result);
        setTotal(response.total_count);
      } else {
        setMaintenanceTime(timeRangeList[3]);
        setLoading(false);
        setEmailList([]);
        setTotal();
        setNoData(true);
      }
    });
  };

  /*** 
    @purpose : Get sorted email settings list
    @Parameter : {body}
    **/
  const getSortedEmailSettingsList = async (body) => {
    setEmailList([]);
    setLoading(true);
    await sortEmailSettingsList(body).then((response) => {
      if (response && response.data) {
        setLoading(false);
        setNoData(false);
        let time = {
          value: response && response.mail_delivery_time.value,
          label: response && response.mail_delivery_time.key,
        };
        setMaintenanceTime(time);
        var result =
          response &&
          response.data &&
          response.data &&
          response.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });
        setEmailList(result);
        setTotal(response.total_count);
      } else {
        setMaintenanceTime(timeRangeList[3]);
        setLoading(false);
        setEmailList([]);
        setTotal();
        setNoData(true);
      }
    });
  };

  /*** 
    @purpose : Handle email listing
    @Parameter : {e}
    **/
  const handleEmailListing = async () => {
    setEmailList([]);
    setLoading(true);
    setNoData(false);
    if (wwid !== "") {
      let body = {
        id: wwid,
        limit: 0,
      };
      await fetchEmailSettingsList(body).then((response) => {
        if (response && response.data) {
          setLoading(false);
          setNoData(false);
          let time = {
            value: response && response.mail_delivery_time.value,
            label: response && response.mail_delivery_time.key,
          };
          setMaintenanceTime(time);
          var result =
            response &&
            response.data &&
            response.data.map(function (el) {
              var o = Object.assign({}, el);
              o.isChecked = false;
              return o;
            });
          setEmailList(result);
          setTotal(response.total_count);
        } else {
          setLoading(false);
          setEmailList([]);
        }
      });
    }
  };

  /*** 
    @purpose : Handle time settings
    @Parameter : {}
    **/
  const handleTimeSettings = async () => {
    setTimeLoading(true);
    let body = { wwid: wwid, mail_delivery_time: maintenanceTime.value };
    await addTimeSettings(body).then((response) => {
      setTimeLoading(false);
      setShowTime(false);
      if (response.success === true) {
        setTimeMessage(response.data);
      } else if (response.success === false) {
        setTimeMessage(response.error);
      }
      setShowTimeMessage(true);
    });
  };

  /*** 
    @purpose : Handle delete email
    @Parameter : {}
    **/
  const handleDeleteEmail = async () => {
    let list = [];
    isCheckBoxSelected.map((val) => list.push(val.id));
    let body = {
      object_id: list,
    };
    await deleteEmailSettings(body).then((response) => {
      if (response.success === true) {
        setSuccessMessage(response.data);
        setShowSuccessMessage(true);
        let body = {
          id: wwid,
          limit: 0,
        };
        getEmailSettingsList(body);
      }
    });
  };

  /*** 
    @purpose : Handle lazy loading
    @Parameter : {}
    **/
  const handleContainerOnBottom = useCallback(async () => {
    if (emailList.length < total) {
      let body = {
        id: wwid,
        limit: limit,
      };
      await fetchEmailSettingsList(body).then((response) => {
        let list = [];
        var result =
          response &&
          response.data &&
          response.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });
        list = emailList.concat(result);
        setEmailList(result);
      });
      setLimit(limit + 10);
    }
  }, [emailList, limit]);

  const containerRef = useBottomScrollListener(handleContainerOnBottom);

  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "dailyprogressemailsetting";
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    const filteredTexts2 = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return (
    <Home>
      <Breadcrumb finalText2={finalText2} finalText={finalText} routes={routes} />
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {lang("dailySellout.achievementEmail")}
          </Accordion.Header>
          <Accordion.Body>
            <div className="user-details">
              <div className="row">
                <div className="col-md-4">
                  {lang("dailySellout.achievementEmail")}
                </div>
              </div>
              <div className="row employeeDetails">
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-5">
                      <label className="mt-2">
                        {lang("dailySellout.employeeWwid")}:
                      </label>
                    </div>
                    <div className="col-md-7">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          value={wwid}
                          onChange={(e) => setWWID(e.target.value)}
                          onBlur={handleEmailListing}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-3">
                      <label className="mt-2">
                        {lang("dailySellout.name")}:
                      </label>
                    </div>
                    <div className="col-md-9">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          value={loginName}
                          disabled
                        />
                        {error === true && (
                          <p className="error">
                            Click on choice to select employee
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-1 p-0">
                  <button
                    className="btn btn-primary"
                    onClick={getEmployeeByWwid}
                    disabled={employeeLoading}
                  >
                    {lang("dailySellout.choice")}
                  </button>
                </div>
                <div className="col-md-5">
                  <div className="row m-0">
                    <div className="col-md-4">
                      <label className="mt-2">
                        {lang("dailySellout.mailDeliveryTimezone")}:
                      </label>
                    </div>
                    <div className="col-md-4">
                      <Select
                        className="ant-select"
                        options={timeRangeList}
                        value={maintenanceTime}
                        onChange={handleDeliveryTime}
                        showSearch={true}
                        optionFilterProp="label"
                        labelInValue={true}
                      />
                    </div>
                    <div className="col-md-4 p-0">
                      <button
                        className="btn btn-primary"
                        onClick={() => setShowTime(true)}
                        disabled={loading}
                      >
                        {lang("dailySellout.deliveryTimeRegistration")}
                      </button>
                    </div>
                    <p className="annotations">
                            ★ {lang("annotations.mailMessage")}
                          </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 mt-3 mb-4">
                  <div className="custom-radio d-inline-block">
                    <input
                      type="radio"
                      id="order1"
                      name="sort-order"
                      value="companyWide"
                      defaultChecked={true}
                      onChange={(e) => handlePeriod(e)}
                    />
                    <label htmlFor="order1">
                      {lang("dailySellout.companyWide")}
                    </label>
                  </div>
                </div>
                <div className="col-md-3 mt-3 mb-4">
                  <div className="custom-radio d-inline-block">
                    <input
                      type="radio"
                      id="order2"
                      name="sort-order"
                      value="bu"
                      onChange={(e) => handlePeriod(e)}
                    />
                    <label htmlFor="order2">BU</label>
                  </div>
                </div>
                <div className="col-md-3 mt-3 mb-4">
                  <div className="custom-radio d-inline-block">
                    <input
                      type="radio"
                      id="order5"
                      name="sort-order"
                      value="salesDivision"
                      onChange={(e) => handlePeriod(e)}
                    />
                    <label htmlFor="order5">
                      {lang("dailySellout.salesDivision")}
                    </label>
                  </div>
                </div>
                <div className="col-md-3 mt-3 mb-4">
                  <div className="custom-radio d-inline-block">
                    <input
                      type="radio"
                      id="order3"
                      name="sort-order"
                      value="branch"
                      onChange={(e) => handlePeriod(e)}
                    />
                    <label htmlFor="order3">
                      {lang("territoryDefinitionMaintenance.branch")}
                    </label>
                  </div>
                </div>
                <div className="col-md-3 mt-3 mb-4">
                  <div className="custom-radio d-inline-block">
                    <input
                      type="radio"
                      id="order4"
                      name="sort-order"
                      value="salesOffice"
                      onChange={(e) => handlePeriod(e)}
                    />
                    <label htmlFor="order4">
                      {lang("dailySellout.district")}
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 companyImg">
                  {period === "companyWide" && (
                    <img src="images/image-all.png" />
                  )}
                  {period === "bu" && <img src="images/image-bu.png" />}
                  {period === "salesDivision" && (
                    <img src="images/image-salesdivision.png" />
                  )}
                  {period === "branch" && <img src="images/image-branch.png" />}
                  {period === "salesOffice" && (
                    <img src="images/image-district.png" />
                  )}
                </div>
                <div className="col-md-9">
                  <p>{lang("dailySellout.selectSalesOffice")}</p>
                  <div className="row mt-4">
                    {(period === "bu" ||
                      period === "salesDivision" ||
                      period === "branch" ||
                      period === "salesOffice") && (
                        <div className="col-md-3">
                          <label>BU:</label>
                          <Select
                            className="ant-select"
                            mode="multiple"
                            options={buList}
                            onChange={handleBUChange}
                            value={selectedBU}
                          />
                        </div>
                      )}
                    {(period === "salesDivision" ||
                      period === "branch" ||
                      period === "salesOffice") && (
                        <div className="col-md-3">
                          <label>{lang("dailySellout.salesDivision")}:</label>
                          <Select
                            className="ant-select"
                            mode="multiple"
                            options={salesDivisionList}
                            disabled={selectedBU.length === 0}
                            onChange={handleSalesDivisionChange}
                            loading={salesDivisionLoading}
                            value={selectedSalesDivision}
                          />
                        </div>
                      )}
                    {(period === "branch" || period === "salesOffice") && (
                      <div className="col-md-3">
                        <label>
                          {lang("territoryDefinitionMaintenance.branch")}:
                        </label>
                        <Select
                          className="ant-select"
                          options={branchList}
                          mode="multiple"
                          disabled={selectedSalesDivision.length === 0}
                          onChange={handleBranchChange}
                          loading={branchLoading}
                          value={selectedBranch}
                        />
                      </div>
                    )}
                    {period === "salesOffice" && (
                      <div className="col-md-3">
                        <label>{lang("dailySellout.district")}:</label>
                        <Select
                          className="ant-select"
                          options={salesOfficeList}
                          mode="multiple"
                          disabled={selectedBranch.length === 0}
                          onChange={handleSalesOfficeChange}
                          laoding={salesOfficeLoading}
                          value={selectedSalesOffice}
                        />
                      </div>
                    )}
                    <div className="col-md-3 mt-4 email-settings">
                      {isLoading && <Spinner animation="border" />}
                      <Button
                        className="btn btn-primary"
                        onClick={handleAddEmailSettings}
                        disabled={name === "" || isLoading ? true : false}
                      >
                        {lang("dailySellout.emailSettings")}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      {emailList.length > 0 && !loading && (
        <div className="card">
          <div className="card-body">
            <p className="record-total">
              {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
              {emailList.length} / {total}
            </p>
            <div
              ref={containerRef}
              className="table-responsive mb-0 hover-table max-height"
            >
              <table className="table" aria-describedby="table">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="custom-checkbox d-inline-block">
                        <input
                          type="checkbox"
                          id="tc1"
                          value="checkAll"
                          name="checkAll"
                          checked={allChecked}
                          onChange={handleCheckbox}
                        />
                        <label htmlFor="tc1">DEL</label>
                      </div>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        handleSortingData({
                          column: "org_code",
                          sortOrder: sortOrgCode === "desc" ? "asc" : "desc",
                        })
                      }
                    >
                      <div className="cursor-pointer">
                        {lang("dailySellout.mailDeliveryOrgCode")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        handleSortingData({
                          column: "org_name",
                          sortOrder: sortOrgName === "desc" ? "asc" : "desc",
                        })
                      }
                    >
                      <div className="cursor-pointer">
                        {lang("dailySellout.mailDeliveryOrgName")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        handleSortingData({
                          column: "jp_org_level",
                          sortOrder: sortOrgLevel === "desc" ? "asc" : "desc",
                        })
                      }
                    >
                      <div className="cursor-pointer">
                        {lang("dailySellout.mailDelivery")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        handleSortingData({
                          column: "modified_date_time",
                          sortOrder:
                            sortModifiedTime === "desc" ? "asc" : "desc",
                        })
                      }
                    >
                      <div className="cursor-pointer">
                        {lang("dailySellout.modifiedDateTime")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                    <th
                      scope="col"
                      onClick={() =>
                        handleSortingData({
                          column: "modified_by_user",
                          sortOrder:
                            sortModifiedUser === "desc" ? "asc" : "desc",
                        })
                      }
                    >
                      <div className="cursor-pointer">
                        {lang("dailySellout.modifiedEmployee")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {emailList &&
                    emailList.length > 0 &&
                    emailList.map((email,index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <div className="custom-checkbox d-inline-block">
                              <input
                                type="checkbox"
                                id={email.id}
                                name={email.id}
                                value={email.id}
                                checked={email.isChecked}
                                onChange={handleCheckbox}
                                key={email.id}
                              />
                              <label htmlFor={email.id} />
                            </div>
                          </td>
                          <td>{email.org_code}</td>
                          <td>{email.org_name}</td>
                          <td>{email.jp_org_level}</td>
                          <td>{email.modified_date_time}</td>
                          <td>{email.modified_by_user}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="mt-4 mb-4">
              <button className="btn btn-primary" onClick={handleDeleteEmail}>
                {lang("dailySellout.delete")}
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Spinner animation="border" />}
      {noData && <div className="noData">No data found</div>}
      <Modal
        size="md"
        className="withdraw-modal"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">Are you sure you want to register ?</div>
          <div className="buttons-group">
            <button className="btn btn-primary" onClick={handleClose}>
              {lang("Buttons.ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        className="withdraw-modal"
        show={showSuccessMessage}
        onHide={handleCloseSuccessMessage}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">{successMessage}</div>
          <div className="buttons-group">
            <button
              className="btn btn-primary"
              onClick={handleCloseSuccessMessage}
            >
              {lang("Buttons.ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        className="withdraw-modal"
        show={showTime}
        onHide={handleCloseTime}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            {lang("dailySellout.timeConfirmation")}
          </div>
          <div className="buttons-group">
            <button className="btn btn-primary" onClick={handleTimeSettings}>
              {lang("Buttons.ok")}
            </button>
            <button className="btn btn-primary" onClick={handleCloseTime}>
              {lang("Buttons.cancel")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        className="withdraw-modal"
        show={showTimeMessage}
        onHide={handleCloseTimeMessage}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">{timeMessage}</div>
          <div className="buttons-group">
            <button
              className="btn btn-primary"
              onClick={handleCloseTimeMessage}
            >
              {lang("Buttons.ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </Home>
  );
}

export default DailyProgress;
